module.exports = __webpack_public_path__ + "media/images/sale-ai_graph2-0ac48552.png";